var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#FD7E14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9621 11.6837V21.6797H14.2921V18.1797L15.9581 16.6257L19.5701 21.6797H21.2501L16.8681 15.7157L21.0821 11.6837H19.3601L14.2921 16.6677V11.6837H12.9621Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.539062 0.679688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon1);
export default __webpack_public_path__ + "static/media/user_icon_1.52833b7d1512c39092bad99771af58d5.svg";
export { ForwardRef as ReactComponent };